import { gsap } from "gsap";

const MV = (function () {

  const jsText = document.querySelectorAll('.js-mv_title-item');

  return {
    init() {

      this.wrapTextWithSpan();
      this.setAnimation();
    },
    wrapTextWithSpan() {

      jsText.forEach(target => {

        const result = [...target.textContent.trim()].map(char => {
          return `<span style="display: inline-block; min-width: 0.25em;">${char}</span>`;
        }).join('');
        target.innerHTML = result;
      });
    },
    setAnimation() {

      const jsLoader = '#js-loader';
      const jsDot = '.js-loader-dot';
      const jsBubble = '.js-mv-bubble [id*=item]';
      const jsTitle = '.js-mv-title';
      const jsText = '.js-mv_title-item span';
      const jsLeadText = '.js-mv_title-lead'; // メインビジュアルのリード文

      gsap.set(
        [jsBubble, jsText, jsLeadText, jsTitle],
        {
          opacity: 0,
          y: 30
        },
      );

      gsap.set(
        [jsBubble],
        {
          opacity: 0,
          y: 60
        },
      );

      gsap.set(jsDot, {
        opacity: 0,
        y: -50
      });

      const tl = gsap.timeline();

      tl.to(
        jsDot,
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          delay: 0.3,
          stagger: {
            amount: 0.3,
            from: "start",
            yoyo: true,
            repeat: 4,
            ease: 'power4.inOut'
          }
        },
      )
      .to(
        jsDot,
        {
          opacity: 0
        }
      )
      .to(
        jsLoader,
        {
          y: '100%'
        },
        '+=0.3'
      )
      .to(
        jsBubble, 
        {
          opacity: 0.4,
          y: 0,
          duration: 0.6,
          stagger: {
            amount: 0.3,
            from: "random",
            ease: "sine.in"
          }
        },
        '+=0.3'
      )
      .to(
        jsTitle, 
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
        },
        '-=0.3'
      )
      .to(
        jsText, {
        opacity: 1,
        y: 0,
        stagger: {
          amount: 1,
          from: "start",
          ease: "sine.in"
        }
      },
        "-=0.3"
      ).to(
        jsLeadText, {
        opacity: 1,
        y: 0,
      },
        "-=0.3"
      )
    }
  }
})();

MV.init();
